import React from 'react';
import style from '../css/Support.module.css';
import Navbar from '../navigation/Navbar';
import HeaderBar from '../components/HeaderBar';
import { FaHome } from 'react-icons/fa';

function Support() {
	return (
		<div>
			<HeaderBar
				text={'Support'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>
			<div
				style={{
					marginTop: 90,
					padding: 20,
				}}
			>
				Website is under construction.
			</div>
		</div>
	);
}

export default Support;
